import React from "react";

function LandScape() {
  return (
    <>
      <meta charSet="UTF-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      {/*=============== FAVICON ===============*/}
      <link
        rel="shortcut icon"
        href="assets/images/favicon.ico"
        type="image/x-icon"
      />
      {/*=============== MYRIAD PRO FONT ===============*/}
      <link rel="stylesheet" href="https://use.typekit.net/yjw8cls.css" />
      {/*=============== LINK TO AOS CSS ===============*/}
      <link rel="stylesheet" href="assets/css/aos.css" />
      {/*=============== LINK TO EXTERNAL CSS ===============*/}
      <link rel="stylesheet" href="assets/css/style.css?ver=4.4" />
      <title>Rotate your device | Britannia Jimjam</title>
      {/*=============== ROTATE SCREEN START ===============*/}
      <div className="rotate-screen-container">
        <div className="rotate-screen-box">
          {/* BOX START */}
          <div className="neon-box d-flex jc-center ai-center flex-column position-rel">
            <div className="neon-box-inner">
              <div className="rotate-sc">
                {/* Rotate Icon */}
                <img
                  src="assets/images/rotate-screen-icon.webp"
                  alt="Rotate Icon"
                  className="img-fluid rotate-icon"
                />
                <h2>Please rotate your device</h2>
                <div className="rotate-error">
                  <img src="assets/images/error.webp" alt="Error Icon" />
                  <p>We don’t support landscape mode</p>
                </div>
              </div>
            </div>
          </div>
          {/* BOX END */}
        </div>
      </div>
      {/*=============== ROTATE SCREEN END ===============*/}
      {/*=============== LINK TO AOS JS ===============*/}
      {/*=============== LINK TO EXTERNAL JS ===============*/}
    </>
  );
}

export default LandScape;
